import { render, staticRenderFns } from "./HuaYinNews.vue?vue&type=template&id=6877a86e&scoped=true&"
import script from "./HuaYinNews.vue?vue&type=script&lang=js&"
export * from "./HuaYinNews.vue?vue&type=script&lang=js&"
import style0 from "./HuaYinNews.vue?vue&type=style&index=0&id=6877a86e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877a86e",
  null
  
)

export default component.exports